import script from "./GalleryBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./GalleryBase.vue?vue&type=script&setup=true&lang=ts"

import "./GalleryBase.vue?vue&type=style&index=0&id=7bb0d752&lang=scss"

const __exports__ = script;

export default __exports__